import moment from 'moment'

export default class SearchFilterAggregations {
  constructor(opts) {
    this.aggs = opts.aggs
    this.role = opts.role
    this.deafult = { value: "All", display: "All" }
  }

  displayValues(filter, val) {
    let newValue;
    switch(filter) { 
      case "publish_month":
        newValue = moment(val, 'MM').format('MMM')
        break
      case "publish_year":
        newValue = val
        break
      case "deadline_day":
        newValue = moment(val, 'DD').format('Do')
        break
      case "size":
        newValue = val
        break
      case "status":
      case "area_director_status":
        newValue = val.replace(/_/g, ' ')
        newValue = newValue.charAt(0).toUpperCase() + newValue.slice(1);
        break
    }
    return newValue
  }

  months() {
    let mo = this.defaultMap("publish_month").sort(this.sortInt)
    mo.unshift(this.deafult)
    return mo
  }

  years() {
    let ye = this.defaultMap("publish_year").sort(this.sortIntReverse)
    ye.unshift(this.deafult)
    return ye
  }

  deadlines() {
    let de = this.defaultMap("deadline_day").sort(this.sortInt)
    de.unshift(this.deafult)
    return de
  }

  sizes() {
    let si = this.defaultMap("size")
    si.unshift(this.deafult)
    return si
  }

  statuses() {
    let val = this.role == "area_director" ? "area_director_status" : "status"
    const st = this.defaultMap(val).filter(stat => stat.value !== "pending").sort(this.sortAlpha);
    st.unshift(this.deafult)
    return st
  }

  defaultMap(filter){
    return this.aggs[filter].buckets.map((k) => {
      return {
        value: k["key"],
        display: this.displayValues(filter, k["key"])
      }
    })
  }

  sortInt(a,b) {
    return a.value - b.value;
  }

  sortIntReverse(a,b) {
    return b.value- a.value;
  }

  sortAlpha(a, b){
    return a.value !== b.value ? a.value < b.value ? -1 : 1 : 0
  }
}
